/**
 * Seeds dedicated painters for Ashe projectile VFX.
 * SP-02/03/04: volley + hawkshot + crystal arrow (not MeshFactory share).
 */
import { registerAbilityVfxPainter } from './abilityVfx.js';
import { buildVolleyArrow } from './abilityVfxVolleyArrow.js';
import { buildHawkshot } from './abilityVfxHawkshot.js';
import { buildCrystalArrow } from './abilityVfxCrystalArrow.js';
import { getAbilityVfxSpec } from './abilityVfxSpecs.js';

registerAbilityVfxPainter('ashe_w', (THREE) => {
  const spec = getAbilityVfxSpec('ashe_w');
  return buildVolleyArrow(THREE, spec || { color: 0x7dd3fc, scale: 0.9 });
});
registerAbilityVfxPainter('ashe_e', (THREE) => {
  const spec = getAbilityVfxSpec('ashe_e');
  return buildHawkshot(THREE, spec || { color: 0xf1f5f9, scale: 1.15 });
});
registerAbilityVfxPainter('ashe_r', (THREE) => {
  const spec = getAbilityVfxSpec('ashe_r');
  return buildCrystalArrow(THREE, spec || { color: 0x67e8f9, scale: 1.85 });
});
